import { render } from "./TheTop.vue?vue&type=template&id=3fd4cd6d&scoped=true"
import script from "./TheTop.vue?vue&type=script&lang=js"
export * from "./TheTop.vue?vue&type=script&lang=js"

import "./TheTop.vue?vue&type=style&index=0&id=3fd4cd6d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fd4cd6d"

export default script